import { ref, watch, type WatchStopHandle } from 'vue'
import { useNotifyStore, NotificationType } from '@/stores/notify'
import { DataBase } from '@/lib/kysely'
import { useDataTimestamp } from '@/composables/useDataTimestamp'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'

export const useRoleWatcher = () => {
  const isWatching = ref(false)
  const userStore = useUserStore()
  const notifyStore = useNotifyStore()
  const router = useRouter()
  let watcher: WatchStopHandle | null = null

  const getRole = async () => {
    const result = await DataBase.selectFrom('user')
      .select(['role'])
      .where('id', '=', userStore.user?.userId ?? '')
      .executeTakeFirstOrThrow()
    return result.role
  }

  const { timestampRefsOn } = useDataTimestamp()
  const startWatching = async () => {
    if (isWatching.value) return
    isWatching.value = true

    const lifetime = new Promise<void>(() => undefined)
    const dbTimestamps = timestampRefsOn(lifetime, ['user'])
    watcher = watch([dbTimestamps], async () => {
      const role = await getRole()
      if (role !== userStore.user?.role) {
        notifyStore.notify(
          `システムロールが変更されました。セキュリティのためログアウトします。`,
          NotificationType.Warning
        )
        setTimeout(async () => {
          await router.push({ name: 'logout' })
        }, 2000)
      }
    })
  }

  const stopWatching = () => {
    if (watcher) {
      watcher = null
    }
    isWatching.value = false
  }

  return {
    startWatching,
    stopWatching
  }
}
